var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIl = function SvgIl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M16.517 9.392h-3.012l-1.506-2.609-1.506 2.61H7.48L8.987 12 7.48 14.609h3.013l1.506 2.61 1.506-2.61h3.012l-1.506-2.608 1.506-2.609Zm-2.668 2.609-.925 1.602h-1.85l-.925-1.602.925-1.603h1.85l.925 1.603ZM12 8.796l.344.596h-.688l.344-.596Zm-2.776 1.602h.689l-.344.597-.345-.597Zm0 3.205.345-.596.344.596h-.689ZM12 15.206l-.344-.597h.688l-.344.597Zm2.776-1.603h-.69l.345-.596.345.596Zm-.69-3.205h.69l-.345.597-.344-.597ZM19.47 2.61H4.53a12.06 12.06 0 0 0-2.77 3.13h20.478a12.064 12.064 0 0 0-2.769-3.13ZM4.53 21.391h14.94a12.06 12.06 0 0 0 2.768-3.13H1.761a12.064 12.064 0 0 0 2.769 3.13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIl;